module.exports = __webpack_public_path__ + "../resources/img/ic_redo_gray950.568ba9c6.svg";